import React from 'react';

import Icon from 'components/Misc/Icon';
import Button from 'components/Ui/Button';

import { useMessengerStore } from 'store/useMessengerStore';

const Nothing = () => {
	// Use messenger's store
	const updateView = useMessengerStore(state => state.updateView);

	// Handle view change to contacts
	const onContacts = () => updateView('contacts');

	return (
		<div className="mt-5 flex flex-col justify-center items-center space-y-4">
			<Icon
				icon="3p"
				className="text-5xl text-neutral-400 dark:text-neutral-500"
			/>

			<div className="max-w-[80%] text-center text-sm text-neutral-500 dark:text-neutral-400">
				Izvēlieties kontaktu no saraksta un uzsāciet sarunu!
			</div>

			<Button
				theme="darker"
				value="Mani kontakti"
				onClick={onContacts}
			/>
		</div>
	);
};

export default Nothing;